import React from "react";
import { Controller } from "react-hook-form";
import { InputLabel } from "../input-label";
import { TextAreaLabel } from "../text-area-label";

interface IFormInputProps {
  name: string;
  control: any;
  label: string;
  placeholder: string;
  type?: "text" | "email" | "password";
  rules?: any;
  isTextArea?: boolean;
  rows?: number;
  readonly?: boolean;
}

export const InputFormLabel: React.FC<IFormInputProps> = ({
  name,
  control,
  label,
  placeholder,
  type = "text",
  rules = {},
  isTextArea = false,
  rows = 10,
  readonly = false,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={rules}
      render={({ field, fieldState }) =>
        isTextArea ? (
          <TextAreaLabel
            label={label}
            placeholder={placeholder}
            rows={rows}
            value={field.value}
            setValue={field.onChange}
            required={rules.required ? true : false}
            error={!!fieldState.error}
            errorMessage={fieldState.error ? fieldState.error.message : ""}
            readonly={readonly}
          />
        ) : (
          <InputLabel
            label={label}
            placeholder={placeholder}
            type={type}
            value={field.value}
            setValue={field.onChange}
            required={rules.required ? true : false}
            error={!!fieldState.error}
            errorMessage={fieldState.error ? fieldState.error.message : ""}
            readonly={readonly}
          />
        )
      }
    />
  );
};
